import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { ROUTE } from "../../../shared/constants/routes";
import { hideNotification } from "../../add-to-ici/redux/slice";
import SessionService from "../../../shared/services/sessionService";
import ConfigService from "../../../shared/services/configService";

const sessionService = new SessionService();
const configService = new ConfigService();

const UNAUTHORISED_STATUS_CODE = 401;
const FORBIDDEN_STATUS_CODE = 403;

const INITIAL_STATE = {
  userData: null,
  authToken: "",
  isAuthInProgress: false,
  isAuthFailed: false,
  isAuthDone: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState: INITIAL_STATE,
  reducers: {
    resetLoginState() {
      return { ...INITIAL_STATE };
    },
    startAuthProcess() {
      return {
        ...INITIAL_STATE,
        isAuthInProgress: true,
      };
    },
    stopAuthProcess(state) {
      state.isAuthInProgress = false;
    },
    loginSuccess(state, action) {
      const { token, userData } = action.payload;
      state.isAuthInProgress = false;
      state.isAuthFailed = false;
      state.isAuthDone = true;
      state.userData = userData;
      state.authToken = token;
    },
    loginFailed(state) {
      state.isAuthInProgress = false;
      state.isAuthFailed = true;
      state.isAuthDone = false;
      state.userData = null;
      state.authToken = "";
    },
  },
});

const { actions, reducer } = loginSlice;

export const { resetLoginState, loginSuccess, loginFailed, startAuthProcess, stopAuthProcess } = actions;

export default reducer;

export const apiCall =
  ({ requestBaseUrl, requestUrl, requestMethod, requestData, history }) =>
  async (dispatch) => {
    dispatch(hideNotification());
    const isIdpEnabled = configService.getOauthFlag().toString();
    let headers = {};
    if (isIdpEnabled === "false") {
      headers = getHeaders(requestData);
    } else {
      headers = getIdpHeaders();
    }
    try {
      const response = await axios({
        baseURL: requestBaseUrl,
        url: requestUrl,
        method: requestMethod,
        headers: headers,
        data: requestData,
      });
      return { response: response.data, error: null };
    } catch (error) {
      console.log(`error in api call [${requestUrl}]:`, error);
      const ifErrorStatus = error && error.response && error.response.status;
      if (
        ifErrorStatus &&
        (error.response.status === UNAUTHORISED_STATUS_CODE || error.response.status === FORBIDDEN_STATUS_CODE)
      ) {
        redirectToLogin(history);
        return;
      }
      return { response: null, error: error };
    }
  };

const getHeaders = (data) => {
  const headers = { "Content-Type": "application/json", icmauthtoken: data };
  return headers;
};

const getIdpHeaders = () => {
  const headers = {
    "Content-Type": "application/json",
    RequestVerificationToken: JSON.parse(localStorage.getItem("AntiForgeryToken")),
  };
  return headers;
};

const redirectToLogin = (history) => {
  sessionService.resetSession();
  history.push(ROUTE.LOG_OUT_ICI);
  window.location.reload();
};

export const apiCallRefreshToken =
  ({ requestBaseUrl, requestUrl, requestMethod, requestData, history }) =>
  async (dispatch) => {
    dispatch(hideNotification());
    const { token, refreshToken } = requestData;
    const headers = {
      "Content-Type": "application/json",
      ICMAuthToken: token.replace('"', "").replace('"', ""),
      ICIRefreshToken: refreshToken,
    };
    try {
      const response = await axios({
        baseURL: requestBaseUrl,
        url: requestUrl,
        method: requestMethod,
        headers: headers,
      });
      return { response: response.data, error: null };
    } catch (error) {
      console.log(`error in api call [${requestUrl}]:`, error);
      const ifErrorStatus = error && error.response && error.response.status;
      if (
        ifErrorStatus &&
        (error.response.status === UNAUTHORISED_STATUS_CODE || error.response.status === FORBIDDEN_STATUS_CODE)
      ) {
        redirectToLogin(history);
        return;
      }
      return { response: null, error: error };
    }
  };
